import Swiper from 'swiper';
import inputSpinner from "bootstrap-input-spinner";
const plg = require("../autoload/functions-comunes");

export default {
  init() {

	setTimeout(function() {
		$('#loading').fadeOut(function() {
			$(this).remove();
		});
	}, 250);

    // JavaScript to be fired on all pages
    	// *****************************************
  		//MODULO DE CALCULADORA
  		// *****************************************
		var swiperCalculadora;
		
		var numEstancias = $(".js-elemento").prop('checked').length;
		var paso_validado = 0;


    	if ($('#swiper-slider-calculadora').length) {

			

    		//comprobacion si cambia hash para ir al paso
		    $(window).on('hashchange',function(){ 
		    	var paso=location.hash.slice(1).split("-")[1];
		    	if (paso == 'NaN'){
		    		paso = 1;
		    	}
		    	siguientePaso(parseInt(paso)-1);
		    	//console.log('voy a :::'+paso);
			});


			var swiperCalculadora = new Swiper('#swiper-slider-calculadora', {
				/*pagination: {
				 el: '.swiper-calculadora-pagination',
				},*/
				 autoHeight: true,
				 simulateTouch: false,
				 shortSwipes: false,
				 longSwipes: false,
				 allowTouchMove: false,
				on: {
					init:function(sw){
					},
					transitionStart: function(sw){
					},
					slideChange : function(sw){

						if (this.realIndex>0){
							$(".js-cabeceracalculadora").addClass("vacia");
						}else{
							$(".js-cabeceracalculadora").removeClass("vacia");
						}

						if (this.realIndex === 1) { // Si está en la primera diapositiva (índice 0)
							$(".js-numero-estancia").trigger("change");
							setTimeout(function(){
								$(".js-numero-estancia").trigger("change");
							}
							,500);
						}


					}
				}
			  });
			  setTimeout(function(){
				  swiperCalculadora.updateAutoHeight();
			  },100);

			
			//compruebo si hay hash al cargar pagina para ir al slide
			var pasoURL=location.hash.slice(1).split("-")[1];

			if (!isNaN(pasoURL) || (pasoURL < 0 && pasoURL > 4)){
				//**************************
				//comprobar validacion paso antes de ir a uno avanzado
				//console.log(">>> voy a slide por hash url"+pasoURL);
				siguientePaso(parseInt(pasoURL)-1);
			}
			/*else{
				siguientePaso(1);
			}*/

			


    		$(':checkbox').prop('checked', false);
    		//desabilitamos el tabulador
    		$(":input, a").attr("tabindex", "-1");
			$(document).keydown(function(objEvent) {
			    if (objEvent.keyCode == 9) {  //tab pressed
			        objEvent.preventDefault(); // stops its action
			    }
			});

			var config = {
			    decrementButton: "", // button text
			    incrementButton: "", // ..
			    groupClass: "", // css class of the resulting input-group
			    buttonsClass: "",
			    buttonsWidth: "",
			    textAlign: "center",
			    autoDelay: 500, // ms holding before auto value change
			    autoInterval: 100, // speed of auto value change
			    boostThreshold: 10, // boost after these steps
			    boostMultiplier: "auto", // you can also set a constant number as multiplier
			    locale: null // the locale for number rendering; if null, the browsers language is used
			}
			$("input[type='number']").inputSpinner(config);
			$('.elementos').slideUp('fast');
			$(".js-numero-estancia").on("change", function (event) {
				// si está habilitada la estancia, no dejo bajar de 1

				if($(this).val()<=1){
					// JB 020425
					// $(this).val(1);
					// $(this).parent().find(".input-group-prepend").addClass("inactivo");
					// $(this).closest(".js-numero-estancia").val(0);
					$(this).closest(".js-numero-estancia").val(1);
					$(this).parent().find(".btn-decrement").addClass("desactivado");

				}else{
					// JB 020425
					//$(this).parent().find(".input-group-prepend").removeClass("inactivo");
					$(this).parent().find(".btn-decrement").removeClass("desactivado");				

				}
				if($(this).val()>=$(this).attr("max")){
					// JB 020425
					// $(this).parent().find(".input-group-append").addClass("inactivo");
					// $(this).closest(".js-numero-estancia").val(0);
					$(this).closest(".js-numero-estancia").val($(this).attr("max"));
					$(this).parent().find(".btn-increment").addClass("desactivado");					

				}else{
					// JB 020425
					//$(this).parent().find(".input-group-append").removeClass("inactivo");
					$(this).parent().find(".btn-increment").removeClass("desactivado");				
				}

				if ($(this).attr("max")==1){
					$(this).parent().find(".btn-increment").addClass("desactivado");		
					$(this).parent().find(".btn-decrement").addClass("desactivado");										
				}


			});

		    
		   	//$(".js-calculadora-metros").blur(function(event) {
		   	$(".js-siguiente").click(function(event) {	
		   		var pasoActual=swiperCalculadora.activeIndex+1;
		   		switch (pasoActual){
		   			case 1: //slide 1 --> pregunta 1
			   			var error=false;
				   		if (isNaN(parseInt($('#metros').val()))){
				   			error=true;	
				   			//console.log('error');	
				   		} 
				   		if (!error){
							//muestro prompt con mensaje si no hay ninuna estancia con 2 unidades
							if (validarEstancias()) {
								// Continuar al siguiente paso
								paso_validado++;
								siguientePaso(pasoActual);
								$("input[name='metros']").removeClass('has-error');
								$(".paso1 .alert").hide();	
							} else {
								$("#modal-prompt").modal('show');
								return false;
							}							
				   		}else{
							$(".paso1 .alert").show();	
							$("input[name='metros']").addClass('has-error');
							swiperCalculadora.update();
				   		}
				   	break;
				   	case 2: //slide 2 --> pregunta 2 configurar opciones estancias
				   		// console.log('paso 2 :: '+numEstancias);
				   		var error=false;
				   		if (numEstancias == 0){
				   			error=true;	
				   			//console.log('error');	
				   		}

				   		if (!error){
							$(".paso2 .alert").hide();
							if(validarOpcionesEstancias()){
								paso_validado++;
								siguientePaso(pasoActual);
							}else{
								$("#modal-prompt-opciones").modal('show');
								return false;
							}
				   		}else{
							$(".paso2 .alert").show();	
							swiperCalculadora.update();
				   		}

				   		break;
				   	case 3:
				   		// console.log('paso 3');
				   		paso_validado++;
				   		siguientePaso(pasoActual);
				   		break;
					case 4:
						// console.log('paso 4');
						paso_validado++;
						siguientePaso(pasoActual);
					break;						
				   	case 5:
				   		// console.log('paso 5');
				   		var error=false;
					    var form = document.getElementById('fPresupuesto');
					    var formJS = $('#fPresupuesto');
					    var nombre = document.getElementById('nombre');
					    var apellidos = document.getElementById('apellidos');
					    var email = document.getElementById('email');
					    var telefono = document.getElementById('telefono');
					    var direccion = document.getElementById('direccion');
					    var optin = document.getElementById('optin');

					    if (form.checkValidity() === false) {
							error=true;							
						}	
						formJS.addClass('was-validated');
					    if (!error){
					    	paso_validado++;
					    	$('#fPresupuesto').calcularPresupuesto();
				   			siguientePaso(pasoActual);
					    	$(this).hide();
							setTimeout(function(){
								$(".js-siguiente").html('Ver últimos proyectos');
								$(".js-siguiente").attr('href', 'https://arindi.odoo.com/proyectos');
								$(".js-siguiente").attr('target', '_blank');
							}, 600);
		
					    }else{
						    $(".paso4 .alert").show();	
						    swiperCalculadora.update();	
					    }	
					    		   		
				   		break;	
				   	case 6:
				   		//console.log('paso 5');
				   		paso_validado++;				   		
				   		siguientePaso(pasoActual);				   		
				   		$(this).hide();
				   		break;	
		   		}	
				plg.PLG_scrollTo(1, $(".cabecera"), 0, -0, 0);
				
			});

		   	$('.js-estancia').click(function(event){
		   		//num_est-76
		   		//est-76
				var _elementos = $(this).closest('.item-estancia').find('.elementos');
		   		if ($(this).prop('checked')){
		   			numEstancias--;
					$(this).closest('.item-estancia').removeClass("inactivo");
					$('#num_'+$(this).attr('id')).val(1);
					$(this).closest('.item-estancia').find(".input-group-prepend").addClass("inactivo");

		   			if (_elementos.find('div').length){
						_elementos.slideDown(100,function(){
							swiperCalculadora.update();
						});
		   			}
		   			
		   		}
		   		else{
		   			numEstancias++;
		   			$('#num_'+$(this).attr('id')).val(0);
					$(this).closest('.item-estancia').addClass("inactivo");
		   			if (_elementos.find('div').length){
						_elementos.hide();
						swiperCalculadora.update();
		   			}
		   		}
	   		
			   });
			   
		   	$('.js-elemento').on('change', function(){//si marca alguna opción, selecciono automáticamente la estancia
		   		var _estancia;
		   		if ($(this).prop('checked')){
			   		_estancia = $(this).closest('.item-estancia').find('.estancia').find('.js-estancia');
			   		if (!_estancia.prop('checked')){
			   			_estancia.prop('checked', true);
			   			numEstancias++;
			   		}
				   //si tiene opciones, la muestro
				   $("#"+$(this).data("opcion")).next().css("display","block");
			   	}else{
					$("#"+$(this).data("opcion")).next().hide();
				}
				swiperCalculadora.update();
				   
				   
		   	});

		    $('.js-elemento-select').select2({
				disable_search_threshold: 0,
				minimumResultsForSearch:9999999
			});

			$("#modal-prompt .js-siguiente").on('click', function(){
				$("#modal-prompt").modal('hide');
				paso_validado++;
				var pasoActual=swiperCalculadora.activeIndex+1;
				siguientePaso(pasoActual);
				plg.PLG_scrollTo(1, $(".cabecera"), 0, -0, 0);

			});
			$("#modal-prompt .js-cerrar").on('click', function(){
				$("#modal-prompt").modal('hide');
			});

			$("#modal-prompt-opciones .js-siguiente").on('click', function(){
				$("#modal-prompt-opciones").modal('hide');
				paso_validado++;
				var pasoActual=swiperCalculadora.activeIndex+1;
				siguientePaso(pasoActual);
				plg.PLG_scrollTo(1, $(".cabecera"), 0, -0, 0);

			});
			$("#modal-prompt-opciones .js-cerrar").on('click', function(){
				$("#modal-prompt-opciones").modal('hide');
			});			

			function validarEstancias() {
				let valido = false;
				$(".cont-estancia input").each(function () {
					if (parseInt($(this).val()) > 1) {
						valido = true;
						return false; // Salir del each en cuanto encuentre uno válido
					}
				});

				return valido;
			}
			function validarOpcionesEstancias() {
				let valido = false;
				$(".item-estancia ").each(function () {
					var option = $(this).find("input.js-elemento");
					option.each(function () {
						if ($(this).is(":checked")) {
							var optionSelect=$(this).data("opcion");
							if($("#"+optionSelect).length > 0){
								if($("#"+optionSelect).val() != ""){
									valido = true;
									return valido;// Salir del each en cuanto encuentre uno válido
								}
							}else{
								valido = true;
								return valido;// Salir del each en cuanto encuentre uno válido
							}
						}
					})
				});

				return valido;
			}
			// $("#select-add-estancias").on('change', function(){
			// 	var _estancia = $(this).val();
			// 	if (_estancia){
			// 		$(".js-add-estancia").removeClass("disabled");
			// 	}else{
			// 		$(".js-add-estancia").addClass("disabled");
			// 	}
			// });
			function addEstancia(){
				// let selectedOptions = [];
				// $checkboxList.find("input:checked").each(function () {
				// 	selectedOptions.push($(this).parent().text().trim());
				// });
				// $button.text(selectedOptions.length > 0 ? selectedOptions.join(", ") : "Selecciona opciones");

				// $(".cont-estancia").removeClass("d-none");
				// var _estancia = $("#select-add-estancias").val();
				// console.log("estancia seleccionada: "+_estancia);

				// var _estanciaTXT = $('#select-add-estancias option[value="'+_estancia+'"]').text();
				// $('#select-add-estancias option[value="'+_estancia+'"]').prop('disabled', true);
				// $("#select-add-estancias").val($("#select-add-estancias option:first").val());

				// var estancia_template=$(".estancia-template").clone();
				// estancia_template.removeClass("estancia-template");
				// estancia_template.data("estancia",_estancia);
				// estancia_template.find(".nombre-estancia").text(_estanciaTXT);
				// estancia_template.find("input").attr("id","estanciaUserHome-"+_estancia);
				// estancia_template.find("input").attr("name","estanciaUserHome-"+_estancia);
				// $(".cont-estancia").append(estancia_template);
				
				// //init eventos estancia añadida
				// estancia_template.find(".btn-increment").on('click', function(){
				// 	$(this).parent().find("input").val(parseInt($(this).parent().find("input").val())+1);
				// });
				// estancia_template.find(".btn-decrement").on('click', function(){
				// 	if ($(this).parent().find("input").val() > 1){
				// 		$(this).parent().find("input").val(parseInt($(this).parent().find("input").val())-1);
				// 	}
				// });
				// estancia_template.find(".trash").on('click', function(){
				// 	var _estancia = $(this).closest(".estancia").data("estancia");

				// 	$('#select-add-estancias option[value="'+_estancia+'"]').prop('disabled', false);
				// 	$(this).closest(".estancia").remove();
					

				// });
				// jQuery("#swiper-slider-calculadora")[0].swiper.update();


				//**version multiple	 */
				let selectedOptions = [];


				// Obtener opciones seleccionadas y agregar elementos dinámicamente
				$checkboxList.find("input").each(function () {
					let _estancia = $(this).val();
					let _estanciaTXT = $('#select-add-estancias option[value="' + _estancia + '"]').text();
		
					$('#select-add-estancias option[value="' + _estancia + '"]').prop("disabled", true);
					if($(this).prop("checked")){
						if ($(".cont-estancia .estancia[data-estancia='" + _estancia + "']").length === 0) {
							let estancia_template = $(".estancia-template").clone();
							estancia_template.removeClass("estancia-template");
							estancia_template.addClass("estancia");
							estancia_template.attr("data-estancia", _estancia);
							estancia_template.find(".nombre-estancia").text(_estanciaTXT);
							estancia_template.find("input").attr("id", "estanciaUserHome-" + _estancia);
							estancia_template.find("input").attr("name", "estanciaUserHome-" + _estancia);
							$(".cont-estancia").append(estancia_template);
				
							// Botones incrementar/decrementar
							estancia_template.find(".btn-increment").on("click", function () {
								$(this).parent().find("input").val(parseInt($(this).parent().find("input").val()) + 1);
							});
				
							estancia_template.find(".btn-decrement").on("click", function () {
								if ($(this).parent().find("input").val() > 1) {
									$(this).parent().find("input").val(parseInt($(this).parent().find("input").val()) - 1);
								}
							});
				
							// Botón eliminar estancia
							estancia_template.find(".trash").on("click", function () {
								let _estancia = $(this).closest(".estancia").data("estancia");
								$('#select-add-estancias option[value="' + _estancia + '"]').prop("disabled", false);
								$('.checkbox-list input[value="' + _estancia + '"]').prop("checked", false);
								$(this).closest(".estancia").remove();
								if($(".cont-estancia").children().length < 1){
									$(".cont-estancia").addClass("d-none");
								}else{
									$(".cont-estancia").removeClass("d-none");

								}
							});
				
							selectedOptions.push(_estanciaTXT);
						}
					}else{
						$(".cont-estancia .estancia[data-estancia='" + _estancia + "']").remove();
						$('#select-add-estancias option[value="' + _estancia + '"]').prop("disabled", false);
			
					}
				});
				if(selectedOptions.length > 0){
					$(".cont-estancia").removeClass("d-none");
				}
				// Actualizar el swiper si es necesario
				if ($("#swiper-slider-calculadora")[0] && $("#swiper-slider-calculadora")[0].swiper) {
					$("#swiper-slider-calculadora")[0].swiper.update();
				}
					
			};

			//*** */
			//multiple selector estancias iniciales
			//*** */
			const $select = $("#select-add-estancias");
			const $button = $(".multiselect-btn");
			const $checkboxList = $(".checkbox-list");
	
			// Generar la lista de checkboxes a partir del select
			$select.find("option").each(function () {
				let value = $(this).val();
				let text = $(this).text();
				$checkboxList.append(`<li><label><input type="checkbox" value="${value}"> ${text}</label></li>`);
			});
	
			// Mostrar u ocultar la lista de opciones
			$button.click(function () {
				$checkboxList.toggle();
			});
	
			// Actualizar el texto del botón cuando se seleccionan opciones
			$checkboxList.on("change", "input[type='checkbox']", function () {
				addEstancia();
			});
	
			// Cerrar el dropdown si se hace clic fuera
			$(document).click(function (event) {
				if (!$(".multiselect-container").is(event.target) && $(".multiselect-container").has(event.target).length === 0) {
					$checkboxList.hide();
				}
			});
			

			


			function siguientePaso(_paso){
		   		if (paso_validado < _paso){
		    		//console.log('>>>> no puede ir a ese paso '+_paso+' y va a '+paso_validado);
		    		_paso = paso_validado;
		    	}


				$(".item-pasos").removeClass('active');
				$(".item-pasos[data-step='"+_paso+"']").removeClass('active');	
				$(".item-pasos[data-step='"+_paso+"']").addClass('hecho');	
				$(".item-pasos[data-step='"+(_paso+1)+"']").addClass('active');	
				//swiperCalculadora.slideNext();
				swiperCalculadora.slideTo(_paso, 1000, false);
		        
				swiperCalculadora.update();
				//cambio hash
				window.location.hash="paso-"+(parseInt(_paso)+1);
//				_paso++;
//				console.log('paso::: '+_paso);

				if (_paso == 1){ //en realidad es el paso 2 del form
					//oculto los elementos de la estancia que no existan
					const ids = $('.cont-estancia input[id^="estanciaUserHome-"]').map(function() {
						return this.id.split('-')[1];
					}).get();
					// console.log("ids********************");
					// console.log(ids);

					$('.item-estancia').each(function() {
						const dataId = $(this).data('clave-estancia');
						if (!ids.includes(String(dataId))) {
							$(this).parent().hide();
						}else{
							$(this).parent().show();
							$(this).find(".js-estancia").prop('checked', true);
							$(this).find(".js-numero-estancia").val(1);
							$(this).find(".elementos").show();
							$(this).find('.js-numero-estancia').attr('max', $('.cont-estancia input[id="estanciaUserHome-'+dataId+'"]:nth-child(2)').val());
							$(this).find('.js-numero-estancia').val($('.cont-estancia input[id="estanciaUserHome-'+dataId+'"]:nth-child(2)').val());
						}
					});
				}
		   	}

		    $('.js-visita').on('click', function(){
		    	$(this).addClass('loading');
				$('.js-visita').html('Enviando...');

			   	data = 	$('#fVisita').serialize();
				$.ajax({
	                url: window.global.ajax_url,
	                data: data,
	                dataType: 'JSON',
	                type: 'POST'
	            })
	            .done( function (result) {
	            	$('.js-visita').removeClass('loading');
	            	$('.js-visita').addClass('loaded');
	            	$('.js-visita').html('ENVIADO');
	            	if (result['resultado'] == 'OK'){
						$('.js-visita').removeClass('loading');
						$('.js-visita').removeClass('loaded');
						$('.js-visita').html('¡SOLICITAR INFORMACIÓN!');
	            		plg.PLG_showModalAlerta('Gracias!','Hemos recibido su solicitud y un asesor financiero se pondrá en contacto con usted para ofrecerle un asesoramiento gratuito de su caso.');
	            	}
	            	else{
						$('.js-visita').removeClass('loading');
						$('.js-visita').removeClass('loaded');
						$('.js-visita').html('¡SOLICITAR INFORMACIÓN!');
	            		plg.PLG_showModalAlerta('UPS!','Ocurrió un error, inténtalo de nuevo más tarde.');
	            	}
	            	swiperCalculadora.update();
	            })
	            .fail(function() {
	                
	            });
		    });


			$('.particularidad').on('click', function(){
				if ($(this).prop('checked')){
					$(".contenedor-opciones-particularidad").show();
				}else{
					$(".contenedor-opciones-particularidad").hide();					
				}
				swiperCalculadora.update();

			});


			$('.eficiencia_energetica').on('click', function(){
				if ($(this).prop('checked')){
					$(".contenedor-opciones-eficiencia").show();
				}else{
					$(".contenedor-opciones-eficiencia").hide();					
				}
				swiperCalculadora.update();

			});

			setTimeout(function(){
				jQuery("#swiper-slider-calculadora")[0].swiper.update();
			},500);

			setTimeout(function(){
				jQuery("#swiper-slider-calculadora")[0].swiper.update();
			},1500);			

	    }	//fin calculadora



  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js